'use strict';

require("core-js/modules/es.promise.finally.js");

var requirePromise = require('./requirePromise');

var getPolyfill = require('./polyfill');

var define = require('define-properties');

module.exports = function shimPromiseFinally() {
  requirePromise();
  var polyfill = getPolyfill();
  define(Promise.prototype, {
    'finally': polyfill
  }, {
    'finally': function testFinally() {
      return Promise.prototype['finally'] !== polyfill;
    }
  });
  return polyfill;
};